import { error, finish } from '../../../modules/system-settings/actions/put-widget-settings';
import api from '../../../api';
import { Amount } from 'src_common/common/amount/Amount';

function createNewValue(value) {
    if (value === null) {
        return null;
    }
    if (value === undefined) {
        return undefined;
    }
    return $appState.configState.precision.newFromAnything(value).value;
}

function createOldValue(value) {
    if (value === null) {
        return null;
    }

    if (value === undefined) {
        return undefined;
    }

    if (typeof value === 'number') {
        return value;
    }

    return $appState.configState.precision.valueOldFormat(new Amount(value));
}

export function request(dispatch, { data }) {
    const dataWithOld = {
        ...data,
        multiples_payout_above_1: createOldValue(data.multiples_payout_above_1),
        multiples_payout_above_2: createOldValue(data.multiples_payout_above_2),
        multiples_payout_above_3: createOldValue(data.multiples_payout_above_3),
        lastlegrum_payout_above: createOldValue(data.lastlegrum_payout_above),
        lastlegrum_limit_resultset: createOldValue(data.lastlegrum_limit_resultset),
        avgnetpo_payout_above: createOldValue(data.avgnetpo_payout_above),
        avgnetpo_stakes_above: createOldValue(data.avgnetpo_stakes_above),
        avgnetpo_net_payout_below: createOldValue(data.avgnetpo_net_payout_below),
        avgnetpo_limit_resultset: createOldValue(data.avgnetpo_limit_resultset),
        liablimit_limit_resultset: createOldValue(data.liablimit_limit_resultset)
    };

    data = {
        ...data,
        multiples_payout_above_1: createNewValue(data.multiples_payout_above_1),
        multiples_payout_above_2: createNewValue(data.multiples_payout_above_2),
        multiples_payout_above_3: createNewValue(data.multiples_payout_above_3),
        lastlegrum_payout_above: createNewValue(data.lastlegrum_payout_above),
        lastlegrum_limit_resultset: createNewValue(data.lastlegrum_limit_resultset),
        avgnetpo_payout_above: createNewValue(data.avgnetpo_payout_above),
        avgnetpo_stakes_above: createNewValue(data.avgnetpo_stakes_above),
        avgnetpo_net_payout_below: createNewValue(data.avgnetpo_net_payout_below),
        avgnetpo_limit_resultset: createNewValue(data.avgnetpo_limit_resultset),
        liablimit_limit_resultset: createNewValue(data.liablimit_limit_resultset)

    };

    api.post('/liabilities-alerts/settings', dataWithOld ).then(
        response => dispatch(finish(data)),
        (errors) => dispatch(error(errors))
    );
}
